import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { WorkTimeUtilizationsGatewayService } from '@wilson/api/gateway';
import { AuthState } from '@wilson/auth/core';
import {
  UserKpisInMinutes,
  WorktimeUtilizationDTO,
  YearMonth,
} from '@wilson/interfaces';
import { endOfMonth } from 'date-fns';
import { map, Observable } from 'rxjs';
import { WorkTimeCache } from './work-time-cache.class';

export class WorkTimeUtilizationsCache extends WorkTimeCache<
  YearMonth,
  UserKpisInMinutes
> {
  private readonly workTimeUtilizationsGatewayService = inject(
    WorkTimeUtilizationsGatewayService,
  );
  private readonly store = inject(Store);
  constructor() {
    super({
      dataFactory: (): Observable<UserKpisInMinutes> => {
        const userId = this.store.selectSnapshot(AuthState.userId) as string;
        const today = new Date();
        return this.workTimeUtilizationsGatewayService
          .getWorkTimeUtilizations([userId], {
            startDatetime: today.toISOString(),
            endDatetime: endOfMonth(today).toISOString(),
          })
          .pipe(
            map(
              (workTimeUtilizations: WorktimeUtilizationDTO) =>
                workTimeUtilizations[userId],
            ),
          );
      },
    });
  }
}
